import { Container, ITextStyle, Text, TextStyle } from 'pixi.js';
import { IEventEmitter, Updatable } from '../interface';

class Damage extends Container implements Updatable, IEventEmitter {
  private textElement: Text;

  constructor(text: string = '', options: Partial<ITextStyle> | TextStyle = {}) {
    super();

    this.textElement = new Text(text, {
      fontSize: 16,
      fontWeight: '700',
      fontFamily: 'ff-providence-sans-web-pro, sans-serif',
      fontStyle: 'normal',
      stroke: 0x000000,
      strokeThickness: 4,
      ...options,
    });
    this.textElement.anchor.set(0.5);
    this.addChild(this.textElement);

    this.textElement.scale.set(8);
    this.zIndex = Infinity;
  }

  public setText(text?: string, options?: Partial<ITextStyle>): void {
    if (options) this.textElement.style = { ...this.textElement.style, ...options };
    if (text) this.textElement.text = text;
  }

  public update(elapsed: number): void {
    this.textElement.scale.x += (2 - this.textElement.scale.x) * 0.1 * elapsed;
    this.textElement.scale.y += (2 - this.textElement.scale.y) * 0.1 * elapsed;

    if (this.textElement.scale.x <= 3) {
      this.textElement.y -= 2 * elapsed;
      this.textElement.alpha -= 0.01 * elapsed;
    }

    if (this.textElement.alpha <= 0) {
      this.emit('destroy');
    }
  }
}

export default Damage;
